(() => {
  const boot = () => {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!widget || widget.dataset.pbCarouselBound) return;
    widget.dataset.pbCarouselBound = 'true';
    const section = widget.closest('.shopify-section') || widget.parentElement;
    const heading = document.createElement('div');
    heading.className = 'pb-review-heading';
    heading.innerHTML = '<p class="pb-review-brand">PINK &amp; BLUE Co.</p><p class="pb-review-average"></p><h2>LOVED BY 37,000+ MOMS</h2><div class="pb-review-stars" role="img"><span aria-hidden="true">★★★★★</span><span class="pb-review-stars-fill" aria-hidden="true">★★★★★</span></div><p class="pb-review-count"></p><button class="pb-review-write" type="button">SHARE THE LOVE</button>';
    const nav = document.createElement('div');
    nav.className = 'pb-review-nav';
    nav.innerHTML = '<button type="button" class="pb-review-prev" aria-label="Previous review"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5 8 12l7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button><div class="pb-review-dots" aria-label="Review navigation"></div><button type="button" class="pb-review-next" aria-label="Next review"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button><p class="pb-review-position" aria-live="polite"></p>';
    let track, pending = false, requested = false, requestTimer, queuedIndex = null, positionFrame = 0, visible = false;
    let itemsCache = [], centers = [], loadedCount = 0, touching = false, scrolling = false, settleTimer, deferredUpdate = false, geometryDirty = true;
    const measure = () => {
      if (!track) return;
      itemsCache = [...track.querySelectorAll(':scope > .jm-review-item')];
      const rect = track.getBoundingClientRect();
      centers = itemsCache.map(item => item.getBoundingClientRect().left - rect.left + track.scrollLeft + item.offsetWidth / 2);
      section.style.setProperty('--pb-review-center-y', (rect.top - section.getBoundingClientRect().top + track.offsetHeight / 2) + 'px');
    };
    const cards = () => itemsCache;
    const current = () => {
      const center = track ? track.scrollLeft + track.clientWidth / 2 : 0;
      return centers.reduce((best, value, i) => Math.abs(value - center) < Math.abs(centers[best] - center) ? i : best, 0);
    };
    const go = i => {
      const items = cards();
      const item = items[Math.max(0, Math.min(i, items.length - 1))];
      if (!item) return;
      const left = centers[items.indexOf(item)] - track.clientWidth / 2;
      track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    const loadMore = () => {
      const button = widget.querySelector('button[aria-label="Show more reviews"]');
      if (button && !button.disabled && !requested) {
        requested = true;
        button.click();
        requestTimer = setTimeout(() => { requested = false; }, 8000);
      }
    };
    const position = () => {
      const items = cards(), index = current();
      if (!items.length) return;
      const dots = nav.querySelector('.pb-review-dots');
      [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      nav.querySelector('.pb-review-prev').disabled = index === 0;
      nav.querySelector('.pb-review-next').disabled = index === items.length - 1 && !widget.querySelector('button[aria-label="Show more reviews"]');
      const total = widget.querySelector('.jm-average-rating-display__review-count')?.textContent.match(/[\d,]+/)?.[0] || items.length;
      const text = matchMedia('(max-width: 699px)').matches ? (index + 1) + ' of ' + total + ' · Swipe for more' : 'Review ' + (index + 1) + ' · Swipe or use the arrows to read more';
      if (nav.querySelector('.pb-review-position').textContent !== text) nav.querySelector('.pb-review-position').textContent = text;
      if (visible && !touching && !scrolling && index >= items.length - 16) loadMore();
    };
    const queuePosition = () => {
      if (!positionFrame) positionFrame = requestAnimationFrame(() => { positionFrame = 0; position(); });
    };
    const update = () => {
      pending = false;
      if (touching || scrolling) { deferredUpdate = true; return; }
      deferredUpdate = false;
      const list = widget.querySelector('.jdgm-review-list');
      const rating = widget.querySelector('.jm-average-rating-display .jm-text:not(.jm-average-rating-display__review-count)');
      const count = widget.querySelector('.jm-average-rating-display__review-count');
      if (!list || !list.querySelector('.jm-review-item') || !rating) return;
      section.classList.add('pb-reviews-skin');
      widget.classList.add('pb-reviews-widget');
      if (!heading.isConnected) widget.before(heading);
      if (!nav.isConnected) widget.after(nav);
      const average = parseFloat(rating.textContent);
      heading.querySelector('.pb-review-average').textContent = Number.isFinite(average) ? average.toFixed(1) : '';
      heading.querySelector('.pb-review-stars').setAttribute('aria-label', average + ' out of 5 stars');
      heading.style.setProperty('--pb-review-fill', Math.min(100, average * 20) + '%');
      heading.querySelector('.pb-review-count').textContent = (count?.textContent || '') + ' for the ' + widget.dataset.productTitle;
      list.querySelectorAll('.jm-review-item__content > .jm-cluster:first-child').forEach(row => row.dataset.pbProduct = widget.dataset.productTitle);
      if (track !== list) {
        track = list;
        track.setAttribute('tabindex', '0');
        track.setAttribute('aria-label', 'Product reviews. Use left and right arrow keys to browse.');
        const settle = () => {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            if (touching) return;
            scrolling = false;
            if (deferredUpdate) schedule(); else queuePosition();
          }, 140);
        };
        track.addEventListener('touchstart', () => { touching = true; clearTimeout(settleTimer); }, {passive:true});
        track.addEventListener('touchend', () => { touching = false; settle(); }, {passive:true});
        track.addEventListener('touchcancel', () => { touching = false; settle(); }, {passive:true});
        let drag = null, dragged = false;
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(min-width:700px)').matches || event.target.closest('button,a,input,textarea,select')) return;
          drag = {id:event.pointerId, x:event.clientX, left:track.scrollLeft};
          dragged = false;
        });
        track.addEventListener('pointermove', event => {
          if (!drag || event.pointerId !== drag.id) return;
          const distance = event.clientX - drag.x;
          if (!dragged && Math.abs(distance) < 5) return;
          if (!dragged) {
            dragged = true; touching = true; clearTimeout(settleTimer);
            track.setPointerCapture(event.pointerId);
            track.setAttribute('data-pb-dragging', '');
          }
          event.preventDefault();
          track.scrollLeft = drag.left - distance;
        });
        const finishDrag = event => {
          if (!drag || event.pointerId !== drag.id) return;
          drag = null; touching = false;
          track.removeAttribute('data-pb-dragging');
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          settle();
        };
        window.addEventListener('pointerup', finishDrag);
        window.addEventListener('pointercancel', finishDrag);
        track.addEventListener('click', event => {
          if (!dragged) return;
          event.preventDefault(); event.stopPropagation(); dragged = false;
        }, true);
        track.addEventListener('scroll', () => { scrolling = true; settle(); queuePosition(); }, {passive:true});
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault(); go(current() + (event.key === 'ArrowRight' ? 1 : -1));
        });
      }
      const nextItems = [...list.querySelectorAll(':scope > .jm-review-item')];
      const changed = nextItems.length !== itemsCache.length || nextItems.some((item, i) => item !== itemsCache[i]);
      if (changed || geometryDirty || !centers.length) { measure(); geometryDirty = false; }
      if (cards().length > loadedCount) {
        loadedCount = cards().length;
        requested = false;
        clearTimeout(requestTimer);
        if (queuedIndex !== null && queuedIndex < loadedCount) {
          const target = queuedIndex; queuedIndex = null;
          requestAnimationFrame(() => go(target));
        }
      }
      if (matchMedia('(max-width: 699px)').matches) {
        list.querySelectorAll('.jm-review-content__body').forEach((body, i) => {
          if (body.dataset.pbPreviewReady) return;
          body.dataset.pbPreviewReady = 'true';
          const wrapper = body.closest('.jm-review-body-wrapper') || body.parentElement;
          let button = wrapper.querySelector('.pb-mobile-review-toggle');
          const expanded = body.hasAttribute('data-pb-expanded');
          const long = body.scrollHeight > 85;
          if (long || expanded) {
            body.setAttribute('data-pb-expandable', '');
            if (!body.id) body.id = 'pb-review-body-' + widget.dataset.productId + '-' + i;
            if (!button) {
              button = document.createElement('button');
              button.type = 'button';
              button.className = 'pb-mobile-review-toggle';
              button.setAttribute('aria-controls', body.id);
              button.addEventListener('click', () => {
                const open = !body.hasAttribute('data-pb-expanded');
                body.toggleAttribute('data-pb-expanded', open);
                button.setAttribute('aria-expanded', String(open));
                button.textContent = open ? 'Read less' : 'Read more';
                requestAnimationFrame(position);
              });
              wrapper.append(button);
            }
            button.hidden = false;
            button.setAttribute('aria-expanded', String(expanded));
            const label = expanded ? 'Read less' : 'Read more';
            if (button.textContent !== label) button.textContent = label;
          } else if (button) button.hidden = true;
        });
      }
      position();
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
    heading.querySelector('.pb-review-write').addEventListener('click', () => widget.querySelector('[data-testid="write-review-button"]')?.click());
    nav.querySelector('.pb-review-prev').addEventListener('click', () => go(current() - 1));
    nav.querySelector('.pb-review-next').addEventListener('click', () => {
      const target = current() + 1;
      if (target >= cards().length) { queuedIndex = target; loadMore(); } else go(target);
    });
    new MutationObserver(schedule).observe(widget, {childList:true, subtree:true});
    new ResizeObserver(() => { geometryDirty = true; if (touching || scrolling) deferredUpdate = true; else { measure(); geometryDirty = false; queuePosition(); } }).observe(widget);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) queuePosition(); }, {rootMargin:'1000px'}).observe(widget);
    let lastWidth = 0;
    new ResizeObserver(entries => { const width = entries[0].contentRect.width; if (width !== lastWidth) { lastWidth = width; schedule(); } }).observe(widget);
    document.fonts?.ready.then(schedule);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

